<div class="object-card-container" (click)="handleClick()">
  <div class="plus-sign">
    <fa-icon [icon]="['fas', 'plus']"></fa-icon>
  </div>
</div>
